import React, { useEffect } from "react";
import { YhPageHeader } from "@src/components/YhPageHeader";
import { useMenuModel } from "../menuModel";
import { TreeDict } from "./TreeDict";
import { YhBox } from "@src/components/YhBox";
import { Button } from "antd";
import FormDict from "./FormDict";
import TableDict from "./TableDict";
import { DetailDrawer } from "./DetailDrawer";


export function Menu() {
    const {
        appCode,
        selectedMenuKeys,
        selectedRowKeys,
        actionType,
        loadApp,
        setActionType,
        setAppCode,
        loadMenuTreeByApp,
        loadTableData,
    } = useMenuModel()

    useEffect(() => {
        loadApp(apps => {
            apps?.length > 0 && setAppCode(apps[0].value)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /**
     * 当选择app后，更新菜单树
     */
    useEffect(() => {
        appCode && loadMenuTreeByApp()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appCode])

    /**
     * 当选择menu后，更新资源
     */
    useEffect(() => {
        selectedRowKeys && loadTableData({ pageNum: 1 })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMenuKeys])



    const action = <div style={{ marginBottom: '-20px' }}>
        <Button type="link" disabled={selectedMenuKeys.length === 0} className={actionType === 'resource' ? 'is-active' : ''} shape="round" onClick={() => setActionType('resource')}>资源信息</Button>
        <Button type="link" className={actionType === 'menu' ? 'is-active' : ''} shape="round" onClick={() => setActionType('menu')}>菜单信息</Button>
    </div>

    return (
        <>
            <YhPageHeader title="菜单管理" />
            <div className="flex">
                <TreeDict />
                <div style={{ width: 'calc(100% - 550px)' }}>
                    <YhBox
                        title={action}
                        style={{ marginBottom: '10px' }}
                    >
                    </YhBox>
                    {
                        selectedMenuKeys.length > 0 ?
                            selectedMenuKeys[0] !== "root"
                                ?
                                actionType === 'resource'
                                    ? <TableDict />
                                    : <FormDict />
                                : <FormDict />
                            : <YhBox
                                style={{ height: 'calc(100% - 80px)' }}
                            >

                            </YhBox>
                    }
                </div>
            </div>
            <DetailDrawer />
        </>
    );
}

